var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlatinumIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 120 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16345 7.16344 0 16 0H104C112.837 0 120 7.16344 120 16V100C120 133.137 93.1371 160 60 160C26.8629 160 0 133.137 0 100V16Z",
    fill: "#B5B5C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19C4 11.268 10.268 5 18 5H102C109.732 5 116 11.268 116 19V100C116 130.928 90.928 156 60 156C29.0721 156 4 130.928 4 100V19Z",
    fill: "url(#paint0_linear_12_2113)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 41C9 34.3726 14.3726 29 21 29H99C105.627 29 111 34.3726 111 41V100C111 128.167 88.1665 151 60 151C31.8335 151 9 128.167 9 100V41Z",
    fill: "url(#paint1_linear_12_2113)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0062 101.112V83.3789L79.8252 110.5L60.0062 101.112Z",
    fill: "#C0CBE0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8252 110.5L60.0062 83.3789L76.6959 88.5944L79.8252 110.5Z",
    fill: "#7289B6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6959 88.5948L60.0062 83.3793L92.3424 72.9482L76.6959 88.5948Z",
    fill: "#8EA3CB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4373 69.8193L60.0062 83.3797L92.3424 72.9486L70.4373 69.8193Z",
    fill: "#C0CBE0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0049 83.3793V50L70.4359 69.819L60.0049 83.3793Z",
    fill: "#8EA3CB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0062 101.112V83.3789L40.1873 110.5L60.0062 101.112Z",
    fill: "#8EA3CB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1873 110.5L60.0062 83.3789L43.3166 88.5944L40.1873 110.5Z",
    fill: "#E1F1FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3166 88.5948L60.0062 83.3793L27.67 72.9482L43.3166 88.5948Z",
    fill: "#7289B6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5752 69.8193L60.0062 83.3797L27.67 72.9486L49.5752 69.8193Z",
    fill: "#C0CBE0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0076 83.3793V50L49.5765 69.819L60.0076 83.3793Z",
    fill: "#E1F1FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_2113",
    x1: 6.24,
    y1: 8.99815,
    x2: 35.479,
    y2: 114.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#A6A5B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898838,
    stopColor: "#D9D9DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12_2113",
    x1: 60,
    y1: 29,
    x2: 60,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CA8C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373F67"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinumIcon);
export default __webpack_public_path__ + "static/media/platinumIcon.b15309080c6eebaabd30c828be800063.svg";
export { ForwardRef as ReactComponent };